// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"petrografie_moduleWrapper__12m4d","documentRow":"petrografie_documentRow__GN0vz","documentRow_marmi":"petrografie_documentRow_marmi__3ObpF"};